"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdkInfo = void 0;
exports.sdkInfo = {
  host: 'npmjs.com',
  version: '10.5.0',
  name: '@kentico/kontent-delivery'
};